<div class="product-detail">
    <div class="wrap-image">
        <img src="assets/images/{{ productSelected.image }}" alt="{{ productSelected.es }}" id="imgSuccess"/>
        <div class="title">{{ productSelected.es }}</div>
    </div>
    <div class="wrap-tabs-header">
        <vcl-tabs [current]="currentTab" [tabs]="listTabs" (tabChange)="onClickTab($event)"></vcl-tabs>
    </div>
    <div *ngFor="let tab of productDesc.tabs; let i = index">
        <section *ngIf="+currentTab == i+1" class="wrap-tab">
            <div *ngFor="let body of tab.body; let index = index">
                <div [ngSwitch]="body.type">

                    <div *ngSwitchCase="'space_break'">
                        <div class="space-break"></div>
                    </div>

                    <div *ngSwitchCase="'title'">
                        <h3 class="title" [innerHTML]="body.desc"></h3>
                    </div>

                    <div *ngSwitchCase="'subtitle'">
                        <h3 class="subtitle" [innerHTML]="body.desc"></h3>
                    </div>

                    <div *ngSwitchCase="'text'">
                        <div class="description" [innerHTML]="body.desc" (click)="handleLoadCallToAction($event)"></div>
                    </div>

                    <div *ngSwitchCase="'cite'">
                        <div class="cite-text" [innerHTML]="body.desc" (click)="handleLoadCallToAction($event)"></div>
                    </div>

                    <div *ngSwitchCase="'table'" class="wrap-table">
                        <vcl-table>
                            <table cdk-table [dataSource]="body.table.datasource">
                                <ng-container *ngFor="let title of body.table.title" [cdkColumnDef]="title.key">
                                    <th cdk-header-cell *cdkHeaderCellDef>{{ title.value }}</th>
                                    <td cdk-cell *cdkCellDef="let element">{{ element[title.key] }}</td>
                                </ng-container>
                                <tr cdk-header-row *cdkHeaderRowDef="body.table.titles;"></tr>
                                <tr cdk-row *cdkRowDef="let row; columns: body.table.titles;"></tr>
                            </table>
                        </vcl-table>
                    </div>

                    <div *ngSwitchCase="'list'" class="botton-line">
                        <ul>
                            <vcl-list>
                                <li *ngFor="let item of body.list" vclListSimple>
                                    <span class="icon icon-itaufonts_chat_enviado"></span>
                                    <vcl-list-text>
                                        <span [innerHTML]="item"></span>
                                    </vcl-list-text>
                                </li>
                            </vcl-list>
                        </ul>
                    </div>

                    <div *ngSwitchCase="'list_description'" class="mb-3">
                        <ul *ngFor="let item of body.body" class="botton-line">
                            <div class="title-list-description mt-4 mb-2 pt-2"><em class="icon {{ item.icon }} align-text-top"></em> {{ item.title }}</div>
                            <vcl-list>
                                <li *ngFor="let item_list of item.list" vclListSimple>
                                    <vcl-list-text>
                                        <span class="description-list" [innerHTML]="item_list"></span>
                                    </vcl-list-text>
                                </li>
                            </vcl-list>
                        </ul>
                    </div>

                    <div *ngSwitchDefault></div>
                </div>
            </div>
        </section>
    </div>
    <app-controls *ngIf="productSelected.code === '951'; else freeInvestment" id="productDetailBtns" [hasPrevious]="true" [nextLabel]="productSelected.code === '951' ? copyService.copies.product_info.continue : copyService.copies.product_selection_go_ahead" (next)="checkBioCatch()"></app-controls>
    <ng-template #freeInvestment><app-controls id="selectProductDetailBtns" [nextLabel]="productSelected.code === '951' ? copyService.copies.product_info.continue : copyService.copies.product_selection_go_ahead" [hasPrevious]="true" [hasNext]="false" (next)="checkBioCatch()"></app-controls></ng-template>
</div>